import React, { memo } from "react";
import pluralize from "pluralize";

import Icon from "../Icons/Icon";

import "./HawkeyeV2Post.scss";

function HawkeyeV2Post(props) {
  const { id, post, toggleExpandPost, onEditPost, onMarkAsCompleted } = props;

  const editPost = (e) => {
    e.stopPropagation();
    onEditPost(id);
  };

  const markAsCompleted = (e) => {
    const sendEmail = post.emailConfiguration.onStatusChange;
    e.stopPropagation();
    onMarkAsCompleted(id, sendEmail);
  };

  return (
    <a onClick={(e) => toggleExpandPost(post)} className="hawkeye-conversations-post">
      <div className="hawkeye-conversations-post-top">
        <h4 className="hawkeye-conversations-post-title">{post.name}</h4>
        <div className="hawkeye-conversations-post-actions">
          {post.isCompleted ? (
            <div className="hawkeye-conversations-post-completed">Completed</div>
          ) : (
            <div className="hawkeye-conversations-edit-actions">
              <div className="hawkeye-conversation-edit-icon" onClick={editPost}>
                <Icon className="hawkeye-conversations-post-icon no-margin" icon="ICON_EDIT" />
              </div>
              <div className="hawkeye-btn hawkeye-btn-secondary" onClick={markAsCompleted}>
                <Icon className="hawkeye-conversations-post-icon" icon="ICON_TICK" />
                <span>Mark as Completed</span>
              </div>
            </div>
          )}
        </div>
      </div>
      <p className="hawkeye-conversations-post-info">
        <span className="hawkeye-conversations-post-meta">
          Created by <b>{post.creator}</b>
        </span>
        <span className="hawkeye-conversations-post-meta">
          Conversation started on {new Date(post.createdOn).toLocaleDateString()}
        </span>
        {post.assignee && (
          <span className="hawkeye-conversations-post-meta">
            Assigned to <b>{post.assignee}</b>
          </span>
        )}
        {post.dueDate && (
          <span className="hawkeye-conversations-post-meta">
            Due Date <b>{d3.timeFormat("%d %b'%Y")(new Date(post.dueDate))}</b>
          </span>
        )}
        <span className="hawkeye-conversations-post-meta">
          <Icon className="hawkeye-conversations-post-icon" icon="ICON_COMMENT" />
          {post.comments > 0 ? pluralize("comment", post.comments, true) : "No comments"}
        </span>
      </p>
    </a>
  );
}

export default memo(HawkeyeV2Post);
